import IconArrowRight from '@apollo/icons/default/IconArrowRight.svg';
import { Button } from '@apollo/orbit';
import { GraphQLInterfaceType, GraphQLObjectType } from 'graphql';
import React from 'react';

import { GraphQLNode, unwrapNestedType } from 'src/lib/graphql/graphqlHelpers';
import { GetIsEntity } from 'src/lib/graphql/subgraphMetadataHelpers';

import { isGraphqlField } from '../helpers/graphqlHelpers';
import { GraphQLPath } from '../helpers/operationPathHelpers';

import { EntityIcon } from './EntityIcon';
import { Field } from './Field';
import { getAllCurrentScalars } from './getFieldToggle/getInsertion';
import { SelectAllButtonAndDropdown } from './SelectAllButtonAndDropdown';
import { SortOrder, ToggleEditorContext, sortFields } from './shared';
import { useFieldToggle } from './useFieldToggle';

export const PossibleType = ({
  type,
  onSelect,
  docsPath,
  toggleEditorContext,
  sortOrder,
  getIsEntity,
}: {
  className?: string;
  type: GraphQLObjectType | GraphQLInterfaceType;
  onSelect: (field: GraphQLNode) => void;
  docsPath: GraphQLPath;
  toggleEditorContext: ToggleEditorContext;
  sortOrder: SortOrder;
  getIsEntity: GetIsEntity | undefined;
}) => {
  const isSelectAllScalarsDisabled = React.useMemo(
    () =>
      type && isGraphqlField(type) && getAllCurrentScalars(type).length === 0,
    [type],
  );
  const fieldToggle = useFieldToggle([...docsPath, type], toggleEditorContext);

  return (
    <>
      <div className="mt-2 flex items-center gap-2">
        <Button
          size="sm"
          variant="hidden"
          className="group font-mono"
          title={type.toString()}
          onClick={() => onSelect && onSelect(type)}
        >
          {type.toString()}
          {getIsEntity?.(unwrapNestedType(type)) && (
            <EntityIcon size="small" className="ml-1" />
          )}
          <IconArrowRight className="ml-1 hidden group-hover:block group-focus-visible:block" />
        </Button>
        <SelectAllButtonAndDropdown
          node={type}
          fieldToggle={fieldToggle}
          isSelectAllScalarsDisabled={isSelectAllScalarsDisabled}
        />
      </div>
      {sortFields(sortOrder, Object.values(type.getFields())).map((field) => (
        <Field
          key={field.name}
          field={field}
          onSelect={(node) => {
            onSelect(type);
            onSelect(node);
          }}
          toggleNodeInOperation={fieldToggle?.toggleInOperation}
          isNodeInOperation={fieldToggle?.isInOperation}
          getIsEntity={getIsEntity}
        />
      ))}
    </>
  );
};
